import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import Button from 'commonComponents/Button/Button';
import styles from './QuoteAndPhoto.module.scss';

const QuoteAndPhoto = ({ headers, text, author, button, photo }) => {
  return (
    <BaseSection { ...headers } anchor='quote-and-photo'>
      <div className={ styles.QuoteAndPhoto }>
        <article>
          <Quote author={ author } text={ text } />
          { button && <Button { ...button } /> }
        </article>
        <figure className={ styles.photo }>
          <img src={ photo } />
        </figure>
      </div>
    </BaseSection>
  );
};

const Quote = ({ text, author: { name, title } }) => {
  return ( 
    <div className={ styles.Quote }>      
      <blockquote className={ styles.text }>{ text }</blockquote>
      <p className={ styles.signature }><b>{ name }</b>, { title }</p>
    </div>  
  );
};

export default QuoteAndPhoto;
